import { IsObject } from 'class-validator';

/**
 * PD-15892 — PUT /api/orders/cart/:clientId/custom-fields body. Keyed by
 * field key; a null value clears that field. Only active order fields placed
 * on the cart sidebar that the caller can see are written, so the rest of
 * `order.customFields` (the platform's own keys among them) is never touched.
 */
export class UpdateCartCustomFieldsDto {
	@IsObject()
	public customFields!: Record<string, unknown>;
}

/**
 * The cart's values for the cart-sidebar fields the caller can see, after the
 * write. System keys and other fields on the order are never returned here.
 */
export type UpdateCartCustomFieldsResponseDto =
	| { success: true; data: { customFields: Record<string, unknown> } }
	| { success: false; error: string };
